import { AsyncPipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PlaceholderDirective } from 'app/shared/form-utils/placeholder.directive';
import { BehaviorSubject } from 'rxjs';


@Component({
    selector: 'filter-input',
    imports: [
        PlaceholderDirective,
        AsyncPipe,
    ],
    styles: [
        `
        :host {
            display: flex;
            align-items: center;
        }
        .input-group-addon {
            background: white;
            border-left: none;
        }
        label {
            margin-right: 10px;
        }
        .clear {
            z-index: 1;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            background: transparent;
            border: none;
            margin-right: 0.5em;
            transition: 0.35s;
            opacity: 0.4;
        }
        .clear:hover {
            opacity: 1;
        }
        `
    ],
    host: {
        class: 'form-group',
    },
    template: `
        <label>Filter:</label>
        <div class="position-relative">
            <input class="form-control" [placeholder]="placeholder" #inputRef (input)="onInput()">
            @if (showClearButton | async) {
                <button type="button" tabindex="-1" class="clear" (click)="onRemove()">
                    <i class="fa fa-times" title="Clear input"></i>
                </button>
            }
        </div>
    `,
})
export class FilterInputComponent {

    @ViewChild('inputRef') inputEl: ElementRef<HTMLInputElement>;

    @Input() placeholder = 'Find a data source...';

    @Output() filter = new EventEmitter<string>();

    showClearButton = new BehaviorSubject(false);

    onInput() {
        this.filter.emit(this.inputEl.nativeElement.value);
        this.showClearButton.next(!!this.inputEl.nativeElement.value);
    }

    onRemove() {
        this.inputEl.nativeElement.value = '';
        this.inputEl.nativeElement.focus();
        this.onInput();
    }
}
